export enum PermissionAcl {
  navigationAccessApps = 'expert.navigation.access_apps',
  navigationAccessTransactions = 'expert.navigation.access_transactions',
  navigationAccessContactParameters = 'expert.navigation.access_contact_parameters',
  navigationAccessThreads = 'expert.navigation.access_threads',
  navigationAccessTimeTracking = 'expert.navigation.access_time_tracking',
  navigationAccessLabels = 'expert.navigation.access_labels',
  navigationAccessBalances = 'expert.navigation.access_balances',
  navigationAccessLoans = 'expert.navigation.access_loans',
  navigationAccessImmobilisations = 'expert.navigation.access_immobilisations',
  navigationAccessFiscalResults = 'expert.navigation.access_fiscal_results',
  navigationAccessTns = 'expert.navigation.access_tns',
  navigationAccessAccountInterests = 'expert.navigation.access_account_interests',
  navigationAccessCaFrameworks = 'expert.navigation.access_ca_frameworks',
  navigationAccessPcgEntries = 'expert.navigation.access_pcg_entries',
  navigationAccessPurchasesInvoices = 'expert.navigation.access_purchases_invoices',
  navigationAccessSalesInvoices = 'expert.navigation.access_sales_invoices',
  navigationAccessGeneralLedger = 'expert.navigation.access_general_ledger',
  navigationAccessJournals = 'expert.navigation.access_journals',
  navigationAccessResultAllocation = 'expert.navigation.access_result_allocation',
  navigationAccessTaxReports = 'expert.navigation.access_tax_reports',
  navigationAccessDocuments = 'expert.navigation.access_documents',
  navigationAccessExports = 'expert.navigation.access_exports',
  navigationAccessCompanyParameters = 'expert.navigation.access_company_parameters',
  navigationAccessAccountingPeriodParameters = 'expert.navigation.access_accounting_period_parameters',
  navigationAccessJournalParameters = 'expert.navigation.access_journal_parameters',
  navigationAccessBankAccountParameters = 'expert.navigation.access_bank_account_parameters',
  navigationAccessAutomationParameters = 'expert.navigation.access_automation_parameters',
  navigationAccessSubscriptionParameters = 'expert.navigation.access_subscription_parameters',
  navigationAccessIntegrationParameters = 'expert.navigation.access_integration_parameters',
  navigationAccessGuestParameters = 'expert.navigation.access_guest_parameters',
  navigationAccessOtherDeclarations = 'expert.navigation.access_other_declarations',
  navigationAccessStocks = 'expert.navigation.access_stocks',
  navigationAccessSuppliers = 'expert.navigation.access_suppliers',
  navigationAccessCutOff = 'expert.navigation.access_cut_off',
  navigationAccessVatFrameworks = 'expert.navigation.access_vat_frameworks',
  navigationAccessWorkbooks = 'expert.navigation.access_workbooks',
  navigationAccessVatDeclarations = 'expert.navigation.access_vat_declarations',
  navigationAccessLeaseContract = 'expert.navigation.access_lease_contracts',
  navigationAccessContractsParameters = 'expert.navigation.access_contracts_parameters',
  navigationAccessBuildings = 'expert.navigation.access_buildings',
  navigationAccessClientGeneralLedger = 'expert.navigation.access_client_general_ledger',
  companyContributorsGet = 'expert.company_contributors.get',
  companyVatConfigGet = 'expert.vat_config.get',
  companyVatDeclarationAutoProcessGet = 'expert.vat_declaration_auto_process.get',
  companyWorksStopGet = 'expert.company_works_stop.get',
  companyMissionGet = 'expert.company_mission.get',
  companyPermanentNoteGet = 'expert.company_permanent_note.get',
  companyImportLabelPlan = 'expert.import.label_plan',
  companyLabelBlock = 'expert.label.block',
  companyLyaGet = 'expert.company_lya.get',
  navigationAccessAnnualAccounts = 'expert.navigation.access_annual-accounts' // TODO à ajouter côté back
}
